import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchTaxes} from './actions';
import {bindActionCreators} from "redux";
import ListView from "../common/ListView";
import {Link} from "react-router-dom";

class TaxesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    search: PropTypes.object.isRequired,
    searchTaxes: PropTypes.func.isRequired,
  };

  render() {
    const {
      salonId, history, searchTaxes, search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
      },
      {
        title: 'Registration Number',
        dataIndex: 'registrationNumber',
        key: 'registrationNumber',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, {taxId}) => {
          const encodedId = encodeURIComponent(taxId);
          return (
            <React.Fragment>
              <Link to={`/tax/update/${encodedId}`}>Edit</Link>
              {' | '}
              <Link to={`/tax/rates/${encodedId}`}>Rates</Link>
            </React.Fragment>
          );
        }
      }
    ];
    return (
      <ListView
        title="Taxes"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchTaxes}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        salonId={salonId}
        rowKey="taxId"
        onAdd={() => history.push('/tax/add')}
      />
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  search: state.tax.searchTaxes,
});

const mapDispatchToProps = dispatch => ({
  searchTaxes: bindActionCreators(searchTaxes, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxesPage);



// WEBPACK FOOTER //
// ./src/Tax/TaxesPage.js